import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCloudSun,
  faTemperatureHigh,
  faWind,
  faTint,
  faMapMarkedAlt,
  faList,
  faExpand,
  faXmark
} from "@fortawesome/free-solid-svg-icons";

// 🔒 Move to env later
const OPEN_WEATHER_KEY = "YOUR_OPENWEATHER_API_KEY";

export default function LocalWeatherPanel({ building }) {

  const [view, setView] = useState("map"); // map | details
  const [mapExpanded, setMapExpanded] = useState(false);

  // Leeds for now – wire lat/lon later
  const mapSrc =
    `https://openweathermap.org/weathermap?basemap=map&cities=true&layer=clouds&lat=53.8008&lon=-1.5491&zoom=9&appid=${OPEN_WEATHER_KEY}`;

  return (
    <>
      {/* =========================
         PANEL CONTENT
      ========================= */}
      <div
        style={{
          padding: "16px",
          height: "100%",
          display: "flex",
          flexDirection: "column",
          overflow: "hidden"
        }}
      >

        {/* Weather hero */}
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "14px",
            padding: "14px",
            borderRadius: "14px",
            background: "#f4f6f9",
            marginBottom: "12px"
          }}
        >
          <FontAwesomeIcon icon={faCloudSun} size="2x" color="#ffb703" />
          <div>
            <div style={{ fontSize: "22px", fontWeight: 900 }}>18°C</div>
            <div style={{ fontSize: "12px", opacity: 0.75 }}>
              {building.location} • Partly Cloudy
            </div>
          </div>
        </div>

        {/* Main area */}
        <div style={{ flex: 1, minHeight: 0 }}>

          {view === "map" && (
            <div
              style={{
                height: "100%",
                borderRadius: "16px",
                overflow: "hidden",
                border: "1px solid #e5e9f0",
                boxShadow: "0 8px 20px rgba(0,0,0,0.10)"
              }}
            >
              <iframe
                title="Weather Map"
                src={mapSrc}
                style={{ width: "100%", height: "100%", border: "none" }}
              />
            </div>
          )}

          {view === "details" && (
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "1fr 1fr",
                gap: "10px"
              }}
            >
              <Metric icon={faTemperatureHigh} label="Feels Like" value="16°C" />
              <Metric icon={faWind} label="Wind" value="12 mph" />
              <Metric icon={faTint} label="Humidity" value="68%" />
              <MetricWide icon={faCloudSun} label="Conditions" value="Partly Cloudy" />
            </div>
          )}

        </div>

        {/* Buttons */}
        <div style={{ display: "flex", gap: "10px", marginTop: "12px" }}>

          <ActionButton
            icon={view === "map" ? faList : faMapMarkedAlt}
            label={view === "map" ? "Show details" : "Show map"}
            onClick={() => setView(view === "map" ? "details" : "map")}
            secondary
          />

          {view === "map" && (
            <ActionButton
              icon={faExpand}
              label="Expand map"
              onClick={() => setMapExpanded(true)}
            />
          )}

        </div>
      </div>

      {/* =========================
         FULL MAP MODAL
      ========================= */}
      {mapExpanded && (
        <>
          {/* Backdrop */}
          <div
            onClick={() => setMapExpanded(false)}
            style={{
              position: "fixed",
              inset: 0,
              background: "rgba(0,0,0,0.7)",
              zIndex: 30000
            }}
          />

          {/* Modal */}
          <div
            style={{
              position: "fixed",
              top: "30px",
              left: "30px",
              right: "30px",
              bottom: "30px",
              background: "#ffffff",
              borderRadius: "20px",
              boxShadow: "0 30px 90px rgba(0,0,0,0.75)",
              zIndex: 30001,
              overflow: "hidden"
            }}
          >
            {/* Close */}
            <div
              onClick={() => setMapExpanded(false)}
              style={{
                position: "absolute",
                top: "14px",
                right: "16px",
                width: "36px",
                height: "36px",
                borderRadius: "50%",
                background: "#f1f3f6",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                cursor: "pointer",
                zIndex: 10
              }}
            >
              <FontAwesomeIcon icon={faXmark} />
            </div>

            <iframe
              title="Expanded Weather Map"
              src={mapSrc}
              style={{ width: "100%", height: "100%", border: "none" }}
            />
          </div>
        </>
      )}
    </>
  );
}

/* =========================
   UI helpers
========================= */

function ActionButton({ icon, label, onClick, secondary }) {
  return (
    <button
      onClick={onClick}
      style={{
        flex: 1,
        padding: "12px",
        borderRadius: "14px",
        border: "none",
        background: secondary ? "#f7f9fc" : "#f4c400",
        fontWeight: 900,
        fontSize: "13px",
        cursor: "pointer",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: "8px",
        boxShadow: secondary
          ? "inset 0 0 0 1px #e5e9f0"
          : "0 6px 14px rgba(0,0,0,0.18)"
      }}
    >
      <FontAwesomeIcon icon={icon} />
      {label}
    </button>
  );
}

function Metric({ icon, label, value }) {
  return (
    <div style={{
      padding: "12px",
      borderRadius: "12px",
      background: "#ffffff",
      boxShadow: "0 2px 6px rgba(0,0,0,0.05)"
    }}>
      <FontAwesomeIcon icon={icon} color="#999" />
      <div style={{ fontSize: "11px", marginTop: "4px", color: "#666" }}>
        {label}
      </div>
      <div style={{ fontWeight: 800 }}>{value}</div>
    </div>
  );
}

function MetricWide({ icon, label, value }) {
  return (
    <div style={{
      gridColumn: "1 / -1",
      padding: "12px",
      borderRadius: "12px",
      background: "#ffffff",
      boxShadow: "0 2px 6px rgba(0,0,0,0.05)"
    }}>
      <FontAwesomeIcon icon={icon} color="#999" />
      <div style={{ fontSize: "11px", marginTop: "4px", color: "#666" }}>
        {label}
      </div>
      <div style={{ fontWeight: 700 }}>{value}</div>
    </div>
  );
}
